// Оплата
import {modalErrorStepText, modalErrorText} from "@js/front/dwstroy.form_e-visa_iran/view";

export function stepPayment (proxy)
{
    let controller = {
        email: false,
        inn: true,
    }

    const data = proxy.data
    const step = 'step'+data.step;

    // Получаем объект с LocalStorage
    const dataLocalStorage = data.getStepLocalStorage(proxy.locStorStepId, data.step);
    if (dataLocalStorage) {
        // Записываем в dataForm данные из LocalStorage
        data.setDataFormAddLocalStorage(data.dataForm[step], dataLocalStorage)
    }

    const dataLS2 = data.getStepLocalStorage(proxy.locStorStepId, 2);

    // Вставляем ФИО на страницу
    if (dataLS2.surname && dataLS2.name && dataLS2.fatherName) {
        setFioText(proxy.fvcContainerId, dataLS2.surname, dataLS2.name, dataLS2.fatherName);
    }

    // Вставляем телефон на странице
    if (dataLS2.phone) {
        setPhoneText(proxy.fvcContainerId, dataLS2.phone);
    }

    // Запись Email
    const email = proxy.fvcContainerId.querySelector('[data-name=email]')
    BX.bind(email, 'input', BX.proxy(eventInputLocationEmail, proxy));

    // Контролируем чекбокс с оплатой
    const payVisaOnline = proxy.fvcContainerId.querySelector('[data-name=payVisaOnline]')
    BX.bind(payVisaOnline, 'click', BX.proxy(eventCheckLocationPay, proxy));

    if (dataLocalStorage) {
        // Если есть данные в ЛС тогда заполняем поле Email
        if (dataLocalStorage.email) {
            email.value = dataLocalStorage.email
        }
        payVisaOnline.checked = dataLocalStorage.payVisaOnline
    } else {
        proxy.data.dataForm[step].payVisaOnline = payVisaOnline.checked
    }

    // Активация поля ИНН при загрузке или по нажатию на чекбокс
    eventCheckPaymentActiveInn(proxy, dataLocalStorage, controller);

    // Получаем общий прайс услуг
    const dataTotalPrise = proxy.data.getStepLocalStorage (proxy.visual.LOCAL_STORAGE_STEP_ID + 'result')

    // Получаем объект цен в HTML и выводим на странице
    if (dataTotalPrise) {
        const listTotalInformation = getListPriseInformation (proxy, dataTotalPrise);
        renderHtmlTotalInformation (proxy, listTotalInformation, dataTotalPrise.generalSum)
    }

    // Формируем новую кнопку, прежнюю скрываем
    setNewButtonHtml(proxy, controller);

    proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm[step], proxy.data.step);
}

// Контролируем чекбокс с оплатой
function eventCheckLocationPay (e) {
    const step = 'step'+this.data.step;
    const innPayment = this.fvcContainerId.querySelector('[data-name=innPayment]');
    const inn = this.fvcContainerId.querySelector('[data-name=inn]');

    this.data.dataForm[step][e.target.dataset.name] = e.target.checked

    // Если нажат "Оплатить онлайн" тогда скрываем "Оплата по счету от юридического лица"
    if (e.target.checked) {
        innPayment.checked = false;
        inn.value = '';
        inn.disabled = true;
        this.data.dataForm[step].inn = false;
    }
    this.data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, this.data.dataForm[step], this.data.step);
}

// Выводим ФИО
function setFioText (fvcContainerId, surname, name, fatherName) {
    const fioSpan  = fvcContainerId.querySelector('[data-name=fio] span')
    const fullName = surname +' '+ name +' '+ fatherName;
    fioSpan.innerText = '';

    fioSpan.insertAdjacentHTML("afterbegin", fullName)
}

// Выводим телефон
function setPhoneText (fvcContainerId, phone) {
    const phoneSpan  = fvcContainerId.querySelector('[data-name=phone] span')
    phoneSpan.innerText = '';

    phoneSpan.insertAdjacentHTML("afterbegin", phone)
}

// Формируем объекты услуг с ценами в HTML из LocalStorage
function getListPriseInformation (proxy, dataTotalPrise) {
    let totalInformation = {}
    Object.entries(dataTotalPrise).forEach((entry) => {
        const [key, value] = entry;
        if (key !== 'generalSum') {
            totalInformation[key] = proxy.data.tableRowHtml (value.name, value.prise, key)
        }
    });
    return totalInformation;
}

// Выводим HTML Разметку таблицы на странице
function renderHtmlTotalInformation (proxy, totalInformation, generalSum) {
    const totalInformationWrapper = proxy.fvcContainerId.querySelector('.total_information_wrapper');
    totalInformationWrapper.innerHTML = ''
    let element = '';

    Object.entries(totalInformation).forEach((entry) => {
        const [key, value] = entry;
        element += value;
    });

    element += proxy.data.tableTotalPriseHtml (generalSum.prise)
    totalInformationWrapper.insertAdjacentHTML("afterbegin", element)
}

// Активация поля ИНН при загрузке или по нажатию на чекбокс
function eventCheckPaymentActiveInn (proxy, dataLocalStorage, controller) {
    const step = 'step'+proxy.data.step;
    const checkbox  = proxy.fvcContainerId.querySelector('[data-name=innPayment]');
    const payVisaOnline  = proxy.fvcContainerId.querySelector('[data-name=payVisaOnline]');
    const input  = proxy.fvcContainerId.querySelector('[data-name=inn]');

    if (proxy.data.dataForm[step][input.dataset.name]) {
        checkbox.checked = true
        input.disabled = false
        input.required = true
        input.value = proxy.data.dataForm[step][input.dataset.name]

        // Проверка поля ИНН и запись его в ЛС
        BX.bind(input, 'input', BX.proxy(eventClickInputLocationInn, proxy));
    }

    checkbox.addEventListener('click', function (e) {
        const target = e.target
        controller.inn = true;

        if (target.checked) {
            input.disabled = false
            input.required = true
            payVisaOnline.checked = false
            proxy.data.dataForm[step].payVisaOnline = false

            // Если есть данные в ЛС то заполняем input
            if (dataLocalStorage[input.dataset.name]) {
                input.value = dataLocalStorage[input.dataset.name]
            }
            // Проверка поля ИНН и запись его в ЛС
            BX.bind(input, 'input', BX.proxy(eventClickInputLocationInn, proxy));
        } else {
            // Удаляем все с инпут и очищаем в ЛС
            const inputContainer = input.closest('.input_container');
            input.disabled = true
            input.required = false
            input.value = ''

            delete proxy.data.dataForm[step][input.dataset.name]
            delete dataLocalStorage[input.dataset.name]

            if (inputContainer.classList.contains('_error')) {
                inputContainer.classList.remove('_error');
                inputContainer.querySelector('.form_additional_text').remove();
            }

            proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, proxy.data.dataForm[step], proxy.data.step);
        }
    })
}

// Проверка поля ИНН и запись его в ЛС
function eventClickInputLocationInn (e) {
    const step = 'step'+this.data.step;

    const inputContainer = e.target.closest('.input_container')
    // const inputs = inputContainer.querySelectorAll('.input_control_js')
    const formAdditionalText = inputContainer.querySelector('.form_additional_text');

    inputContainer.classList.remove('_error')
    inputContainer.classList.remove('_success')
    if (formAdditionalText) formAdditionalText.remove();

    this.data.validateNum(e.target)

    if (e.target.value) {
        this.data.dataForm[step][e.target.dataset.name] = e.target.value
    }

    this.data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, this.data.dataForm[step], this.data.step);
    // this.proxy.data.inputControlClickBtn(inputs, this.proxy)
}

// Формируем новую кнопку для отправки формы
function setNewButtonHtml (proxy, controller) {
    const formButtonWrapper = proxy.btnWrapperId.querySelector('.form_button_wrapper')
    proxy.bNext.style.display = 'none'
    let textBtn = proxy.message.BTN_REQUEST;

    if (proxy.fn.getMobileDevise()) {
        textBtn = proxy.message.BTN_PAY;
    }
    const buttonHtml = '<div class="b_send_request">'+textBtn+'</div>';
    formButtonWrapper.insertAdjacentHTML("beforeend", buttonHtml)

    const btn = formButtonWrapper.querySelector('.b_send_request')
    const data = {
        proxy: proxy,
        controller: controller
    }
    BX.bind(btn, 'click', BX.proxy(eventClickBtn, data));
}

// Контролируем уведомления об ошибке
function controlInputError (proxy, input, controller) {
    const messageHtml = proxy.data.messageHtml;
    const inputContainer = input.closest('.input_container');
    const required = input.hasAttribute('required');
    const value = input.value;
    const dataName = input.dataset.name;

    // Отбираем обязательные поля и проверяем их
    if (required && !value) {
        setClassError(inputContainer, messageHtml('ERROR_REQUIRED_FIELD'), proxy);
        controller[dataName] = false
    }

    if (dataName === 'inn' && value) {
        if (!checkInnShort(value)) {
            controller[dataName] = false
            setClassError(inputContainer, messageHtml('ERROR_INPUT_INN'), proxy);
        } else {
            controller[dataName] = true
            setClassSuccess(inputContainer, proxy);
        }
    }

    if (dataName === 'email' && value) {
        if (!isEmailValid(value)) {
            controller[dataName] = false
            setClassError(inputContainer, messageHtml('ERROR_INPUT_EMAIL'), proxy);
        } else {
            controller[dataName] = true
            setClassSuccess(inputContainer, proxy);
        }
    }

    function setClassError (inputContainer, errorText) {
        inputContainer.classList.add('_error');
        inputContainer.insertAdjacentHTML("beforeend", errorText);
        // proxy.data.btnNext = false;

        const checkIco = inputContainer.querySelector('.check_ico');

        // Удаляем дополнительный текст по нажатию на крестик
        checkIco.addEventListener("click", function (e) {
            const inputError = e.target.closest('.input_container')
            if (inputError.classList.contains('_error')) {
                inputError.classList.remove('_error');
                inputError.querySelector('.form_additional_text').remove();
            }
        })
    }

    function setClassSuccess (inputContainer) {
        inputContainer.classList.add('_success');
    }

    /** Короткая функция проверки ИНН юрлиц, физлиц и ИП
     * @param {string} value - строка для проверки
     * @return boolean
     */
    function checkInnShort(value){
        if(typeof value !== 'string' ||
            (value.length !== 10 && value.length !== 12) ||
            value.split('').some((symbol) => isNaN(Number(symbol)))
        ) return false;

        if(value.length === 10){
            return Number(value[9]) === (value.split('').slice(0, -1)
                    .reduce(
                        (summ, symbol, index) =>
                            [2, 4, 10, 3, 5, 9, 4, 6, 8][index] * Number(symbol) + summ,
                        0)
                % 11) % 10;

        }else if(value.length === 12){
            let checkSumOne = (value.split('').slice(0, -2)
                    .reduce(
                        (summ, symbol, index) =>
                            [7, 2, 4, 10, 3, 5, 9, 4, 6, 8][index] * Number(symbol) + summ,
                        0)
                % 11 ) % 10;

            let checkSumTwo = (value.split('').slice(0, -1)
                    .reduce(
                        (summ, symbol, index) =>
                            [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8][index] * Number(symbol) + summ,
                        0)
                % 11 ) % 10;

            return (checkSumOne === Number(value[10]) && checkSumTwo === Number(value[11]));
        }
    }

    // Вылидация Email
    function isEmailValid(value) {
        const emailRegexp = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
        return emailRegexp.test(value);
    }
}

// Ввод Email и запись его в ЛС
function eventInputLocationEmail (e) {
    const step = 'step'+this.data.step;
    e.target.value;
    const inputContainer = e.target.closest('.input_container')
    this.data.deleteSuccessErrorText(inputContainer)

    this.data.dataForm[step][e.target.dataset.name] = e.target.value
    this.data.setStepLocalStorage(this.visual.LOCAL_STORAGE_STEP_ID, this.data.dataForm[step], this.data.step);
}

// Контролируем ошибки в полях
function controlInputs (data) {
    // Очищаем от ошибок при клике
    const inputContainer = data.proxy.fvcContainerId.querySelectorAll('.input_container')
    inputContainer.forEach(input => data.proxy.data.deleteSuccessErrorText(input))
    // inputContainer.forEach(input => deleteSuccessErrorText(input))

    // Проверка на Email
    const email = data.proxy.fvcContainerId.querySelector('[data-name=email]');
    if (email) {
        controlInputError(data.proxy, email, data.controller)
    }

    // Проверка INN
    const innPayment = data.proxy.fvcContainerId.querySelector('[data-name=innPayment]');
    if (innPayment.checked) {
        const inputInn  = data.proxy.fvcContainerId.querySelector('[data-name=inn]');
        controlInputError(data.proxy, inputInn, data.controller)
    }
}

// Клик по кнопке "Отправить заявку"
function eventClickBtn (e) {
    controlInputs (this)
    if (this.controller.email && this.controller.inn) {
        let data = getDataForm (this.proxy);

        // Заглушка в момент работы
        if (this.proxy.debug.errorModal) {
            const error = this.proxy.data.htmlText('MODAL_DIALOG_ERROR')
            this.proxy.fvcContainerId.insertAdjacentHTML("beforeend", error)

            const close = this.proxy.fvcContainerId.querySelector('.modal_close_end')
            close.addEventListener('click', closeEnd)
            function closeEnd (e) {
                const modalDialog = e.target.closest('.modal_dialog');
                modalDialog.remove();
            }

            // Общий массив данных перед отправкой
            if (this.proxy.debug.logDataResul) console.log(data);

        } else {
            const loader = this.proxy.data.htmlText('MODAL_DIALOG_LOADER')
            this.proxy.fvcContainerId.insertAdjacentHTML("beforeend", loader)
        }

        // отправка данные на сервер
        if (!this.proxy.debug.notSetBxAjaxResult) setBxAjaxResult(this.proxy, data);
    }
}

// Формируем массив данных для отправки на сервер
function getDataForm (proxy) {
    let result = {}
    const data = proxy.data

    for (let i = 1; i <= 9; i++) {
        let res = {}
        const dataLC = data.getStepLocalStorage(proxy.locStorStepId, i);
        Object.entries(dataLC).forEach((entry) => {
            const [key, value] = entry;
            if (value) {
                res[key] = value
            }
        });
        result['step' +i] = res
    }

    // проверка step на заполнение данных
    checkDataLocalStorage(result, proxy)

    // Проверка на заполнение статуса на step2 (доработать - вывнести все в отдельный метод)
    // if(!result.step2.familyStatusId)
    // {
    //     const error = data.htmlText('MODAL_DIALOG_ERROR_STEP_2')
    //     proxy.fvcContainerId.insertAdjacentHTML("beforeend", error)
    //
    //     const close = proxy.fvcContainerId.querySelector('.modal_close_end')
    //     close.addEventListener('click', closeEnd)
    //
    //     function closeEnd (e) {
    //         const modalDialog = e.target.closest('.modal_dialog');
    //         modalDialog.remove();
    //     }
    //
    //     proxy.data.setStepLocalStorage(proxy.visual.STEP_ID, 2)
    //     setTimeout(function(){
    //         location.reload();
    //     }, 1500);
    // }

    result.resItems = proxy.params.RESULT
    result.config = proxy.params.CONFIG
    result.result = data.getStepLocalStorage(proxy.locStorStepId + 'result')
    result.stepId = proxy.stepId
    result.utm = proxy.utm
    result.application = proxy.debug.application
    result.params = proxy.params.PARAMS
    result.server = proxy.params.PARAMS.SERVER

    return result;
}

// Проверка данных в Local Storage перед отправкой на сервер
function checkDataLocalStorage (data, proxy)
{
    const step1 = data['step1']
    const step2 = data['step2']
    const step3 = data['step3']
    const step4 = data['step4']
    const step5 = data['step5']
    const step6 = data['step6']
    const step7 = data['step7']
    const step8 = data['step8']
    const step9 = data['step9']

    // (тестирование) Перезаписываем данные в step
    // console.log(data)
    // step2.age = '';
    // proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, step2, 2);

    // Проверяем заполнение step1
    // if (Object.keys(step1).length === 0
    //     || !step1.id
    //     || step1.relativesIranId !== '294')
    // {
    //     showReloadFunction(proxy, 1)
    // }

    // Проверяем заполнение step2
    if (Object.keys(step2).length === 0 || !step2.date
        || !step2.addressRegistration || !step2.familyStatusId
        || !step2.fatherName || !step2.name || !step2.phone
        || !step2.profession || !step2.surname)
    {
        showReloadFunction(proxy, 2)
    } else if (!step2.age || !step2.dateRFC2822) {
        step2.date = '';
        proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, step2, 2);
        showReloadFunction(proxy, 2)
    }

    // Проверяем заполнение step3
    if (Object.keys(step3).length === 0 || step3.size === 0) {
        showReloadFunction(proxy, 3)
    }

    // Проверяем заполнение step4
    if (Object.keys(step4).length === 0 || step4.size === 0) {
        showReloadFunction(proxy, 4)
    }

    // Проверяем заполнение step5
    if (Object.keys(step5).length === 0 || !step5.hotelsPlaces) {
        showReloadFunction(proxy, 5)
    }

    // Проверяем заполнение step6
    if (Object.keys(step6).length === 0 || !step6.date) {
        showReloadFunction(proxy, 6)
    } else if (!step6.dateRFC2822) {
        step6.date = '';
        proxy.data.setStepLocalStorage(proxy.visual.LOCAL_STORAGE_STEP_ID, step6, 6);
        showReloadFunction(proxy, 6)
    }

    // Проверяем заполнение step7
    if (Object.keys(step7).length === 0) {
        showReloadFunction(proxy, 7)
    }

    // Проверяем заполнение step8
    if (Object.keys(step8).length === 0) {
        showReloadFunction(proxy, 8)
    }

    // (тестироваие) Проверяем заполнение step8
    // if (Object.keys(step9).length === 0 || step9.email) {
    //     showReloadFunction(proxy, 9)
    // }

    // Запускаем функции
    function showReloadFunction(proxy, id) {
        showPopPapError (proxy, id)
        reloadStepError (proxy, id)
        return false
    }

    return true
}

// Показываем окно ошибки
function showPopPapError (proxy, stepId)
{
    const data = proxy.data

    const error = data.modalErrorStepText('ERROR_STEP_'+stepId)
    proxy.fvcContainerId.insertAdjacentHTML("beforeend", error)

    const close = proxy.fvcContainerId.querySelector('.modal_close_end')
    close.addEventListener('click', closeEnd)

    function closeEnd (e) {
        const modalDialog = e.target.closest('.modal_dialog');
        modalDialog.remove();
    }
}

// Перенаправляем на step если есть ошибки
function reloadStepError (proxy, stepId)
{
    proxy.data.setStepLocalStorage(proxy.visual.STEP_ID, stepId)
    setTimeout(function(){
        location.reload();
    }, 3500);
}

// Отправляем данные на сервер
function setBxAjaxResult (proxy, dataResult)
{
    const url = proxy.urlFolderAjax;
    BX.ajax({
        url: url + 'addApplication.php',
        data: dataResult,
        method: 'POST',
        dataType: 'json',
        timeout: 30,
        async: true,
        processData: true,
        scriptsRunFirst: true,
        emulateOnload: true,
        start: true,
        cache: false,
        onsuccess: function(data){
            if (data) {
                // Удаляем loader
                const loader = proxy.fvcContainerId.querySelector('.loader_js')
                if (loader) loader.remove();
            }

            // Распечатываем результат ответа
            if (proxy.debug.getAjaxLog) console.log(data);

            // Удаляем данные с ЛС
            if (!proxy.debug.notDelLocalStorageAjax) proxy.fn.delLocalStorage(proxy);

            // перенаправляем на страницу result
            if (!proxy.debug.notLocation) location.href = '/result/?visa=1'

            /*
            // Не перенаправляем на другую страницу
            let locHref = true
            if (proxy.debug.notLocation) locHref = false

            if (!proxy.debug.errorModal) {
                if (data['CRM']['PAY_ONLINE'] === 'Y') {
                    proxy.data.modalDialogSuccess(proxy, data['CRM']['TINKOFF_URL'], locHref)
                } else {
                    proxy.data.modalDialogSuccess(proxy, false, locHref)
                }
            }
            */
        },
        onfailure: function(data){
            console.error(data)
        }
    });
}

// Удаляем данные с LS
/*function delLocalStorage (proxy) {
    const localStorageId = proxy.visual.LOCAL_STORAGE_STEP_ID

    // Устанавливаем step 1
    // proxy.data.setStepLocalStorage(proxy.stepId, 1);

    // Удаляем данные с LC
    localStorage.removeItem(proxy.stepId);
    localStorage.removeItem(localStorageId + 'result');
    for (let i = 1; i < 10; i++) {
        localStorage.removeItem(localStorageId + i);
    }
}*/